import { ColorConversionState } from "@/store/types/color-conversion.state";
import { Module } from "vuex";
import { RootState } from "@/store/types/root.state";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";

export const state: ColorConversionState = {
    displayingChapter: 0,
    sliderHue: 180,
    sliderLuminance: 82,
    sliderR: 174,
    sliderG: 204,
    sliderB: 233,
    nOctaves: 5,
    baseHue: 180,
    attack: 1,
};

const namespaced = true;

export const ColorConversionModule: Module<ColorConversionState, RootState> = {
    namespaced,
    actions,
    getters,
    mutations,
    state,
}